import type { GA4AnalyticsEvent } from '@/domain/shared/types';

export interface UserReviewsEventProps {
  element: 'Toggle' | 'Dropdown' | 'Button' | 'Chip' | 'Clickable text';
  description: string;
  result: string | number | readonly string[] | undefined;
  ecommerce?: {
    reviewTransalted?: {
      id: string;
      overallRating: number;
      country: string;
      partyComposition: string;
    };
  };
}

export function createUserReviewsEvent({
  description,
  element,
  ecommerce,
  result,
}: UserReviewsEventProps): GA4AnalyticsEvent {
  return {
    event: 'reviews',
    description,
    element,
    type: window.navigator.language || '',
    result: result?.toString().toLowerCase(),
    interaction: true,
    ecommerce,
  };
}
